'use strict';

angular.module('libraryModule')

.factory('multiDownloadAction', function ($window)
{
    return {
        name: 'download',
        tooltip: 'Download',
        buttonClass: 'btn btn-primary',
        template: '<span><i class="material-icon material-icon-file-download"></i> Download</span>',
        act: function (models)
        {
            let ids = models.map((model) => {
                return 'id[]=' + model.id;
            });

            $window.open('/api/assets/multi-download?' + ids.join('&'));
        },
        show: function (models)
        {
            let modelsToUse = models.filter((itm) => {
                return itm.type !== 'folder' && !itm.isEmpty;
            });

            if (!modelsToUse.length) {
                return  false;
            }

            return true;
        }
    };
})

.config(function ($provide)
{
    $provide.decorator('mediaViewOptions', function ($delegate, $state, kdGate, multiDownloadAction, appConfig, resourceIcons)
    {
        const showGate = () => kdGate.allows('library.edit');

        $delegate.list.tableClass = 'table';
        $delegate.toolbar.map((button) => button.show = showGate);

        $delegate.getIcon = (model, isGrid) =>
        {
            var prefix = isGrid ? 'grid-' : '';

            var iconClass = prefix && resourceIcons[prefix + model.type] ?
                resourceIcons[prefix + model.type] : resourceIcons[model.type];

            if (!model.links.thumb) {
                angular.forEach(model.format, (f) => {
                    iconClass += ' icon-' + f;
                });
            }

            return iconClass;
        };

        $delegate.actions.map((action) => {
            switch (action.name) {
                case 'edit':
                    action.show = (models) => {
                        return models.length === 1 && kdGate.allows('library.edit');
                    };

                    action.act = (models) =>
                    {
                        if (models[0].type && models[0].type === 'folder') {
                            $state.go('.edit-folder-thumb', {id: models[0].id});
                        } else {
                            $state.go('.edit', {id: models[0].id});
                        }
                    };
                    break;
                default:
                    action.show = (models) => {
                        return models.length >= 1 && kdGate.allows('library.edit');
                    };
            }
        });

        if (appConfig.basket.direct_download) {
            $delegate.actions.push(multiDownloadAction);
        }

        if (appConfig.basket.lib_default_view === 'list') {
            $delegate.views = $delegate.views.reverse();
        }

        $delegate.list.columns.splice(2, 1, {
            label: 'Formats',
            template: `<span class="badge"
                             ng-if="::model.type !== 'folder'"
                             ng-repeat="format in model.format track by $index">{{ format }}</span>`,
            sortable: false,
        });

        if (appConfig.basket.enabled) {
            $delegate.onItemClick = function ($event, model)
            {
                $event.stopPropagation();

                if (model.type === 'folder') {
                    $state.go('admin.media', {
                        folder_id: model.id,
                        offset: null,
                        name: null
                    });
                } else {
                    $state.go('admin.media.basket', {
                        id: model.id
                    });
                }
            };

            $delegate.list.columns.splice(1, 0, {
                label: 'In kitbag',
                template: `<span ng-if="model.numInBasket">{{ model.numInBasket }}</span>`,
                sortable: false,
            });
        }

        $delegate.rowClassifier = (model, classes) => {
            classes[model.type] = true;
            return classes;
        };

        $delegate.grid.fields.push({
            template: `<span class="badge"
                             ng-show="model.numInBasket">
                         {{ model.numInBasket }}</span>
                       <span class="icon-folder"
                             ng-if="::model.type === 'folder'">
                         <i class="material-icon material-icon-folder-open"></i></span>
                       <span class="icon-asset"
                             ng-if="::model.type !== 'folder'">
                         <i class="material-icon material-icon-insert-drive-file"></i></span>`
        });

        return $delegate;
    });

});
